// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify from 'bemify-js';

import { Badge } from '@zapier/common-components';
import { Link } from '@zapier/design-system';
import { buildCommonComponent } from '@zapier/legacy-components';

import IconButton from 'web-ssr/app/common/components/IconButton';
import Logo from 'web-ssr/app/common/components/Logo';
import 'web-ssr/app/common/components/ContentHeader/HeaderBlock.scss';

const bem = bemify('header-block');

export const buildCommonHeaderComponent = buildCommonComponent(bem());

export const HeaderBlock = buildCommonHeaderComponent();
export const HeaderBlockContainer = buildCommonHeaderComponent('__container');
export const HeaderBlockInnerWrapper = buildCommonHeaderComponent('__wrapper');
export const HeaderBlockOverlay = buildCommonHeaderComponent('__overlay', 'a');
export const HeaderBlockLogo = buildCommonHeaderComponent('__logo', Logo);
export const HeaderBlockMenuControls = buildCommonHeaderComponent('__controls');
export const HeaderBlockServicesSearch = buildCommonHeaderComponent(
  '__service-search'
);
export const HeaderBlockHeaderLinks = buildCommonHeaderComponent(
  '__links-container'
);

export const HeaderMenuButton = buildCommonHeaderComponent(
  '__menu-button',
  IconButton
);

export const HeaderSignUpCta = props => {
  return (
    <span className={bem('__sign-up-cta')}>
      <Link color="inherit" {...props}></Link>
    </span>
  );
};

export const HeaderBadge = buildCommonHeaderComponent(
  '__developer-badge',
  Badge
);

export default HeaderBlock;
